<template>
  <div>
    <!-- Start Breadcrump Area  -->
    <div
      class="rn-page-title-area pt--120 pb--190 banner-service-details-notin"
      data-black-overlay="5"
    >
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="rn-page-title text-center pt--100">
              <h1 class="headingtitle">Protección de Datos</h1>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Breadcrump Area  -->

    <div class="rn-service-details rn-section-gap bg_color--1 content-service-details-notin">
      <v-container>
        <v-row>
          <v-col lg="12">
            <div class="inner">
              <!-- Start Single Content  -->
              <v-row
                class="pb--80 align-items-center text-justify"
              >
                <v-col lg="12" md="12" cols="12">
                  <div class="contentlegal details mt_md--30 mt_sm--30" v-if="NOTARIA.LopdPage" v-html="NOTARIA.LopdPage"></div>
                  <div class="contentlegal details mt_md--30 mt_sm--30" v-if="!NOTARIA.LopdPage">
                    <h2>Protección de datos de carácter personal según la LOPD</h2>
                    <!-- <p>
                    {{NOTARIA.Nombre}}, en aplicación de la normativa vigente en materia de protección de datos de carácter personal, informa que los datos personales que se recogen a través de los formularios del sitio web: {{NOTARIA.Ruta}}, se incluyen en los ficheros automatizados específicos de usuarios de los servicios de la recogida y tratamiento automatizado de los datos de carácter personal tiene como finalidad el mantenimiento de la relación comercial y el desempeño de tareas de información, formación, asesoramiento y otras actividades propias de {{NOTARIA.Nombre}}.
                    <br>
                    Estos datos únicamente serán cedidos a aquellas entidades que sean necesarias con el único objetivo de dar cumplimiento a la finalidad anteriormente expuesta.
                    <br>
                    {{NOTARIA.Nombre}} adopta las medidas necesarias para garantizar la seguridad, integridad y confidencialidad de los datos conforme a lo dispuesto en el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de los mismos.
                    <br>
                    El usuario podrá en cualquier momento ejercitar los derechos de acceso, oposición, rectificación y cancelación reconocidos en el citado Reglamento (UE). El ejercicio de estos derechos puede realizarlo el propio usuario a través de email a: web@notin.net o en la dirección: Av. Severo Ochoa, 2, 30100 Murcia.
                    <br>
                    El usuario manifiesta que todos los datos facilitados por él son ciertos y correctos, y se compromete a mantenerlos actualizados, comunicando los cambios a {{NOTARIA.Nombre}}
                    </p>

                    <h2>Finalidad del tratamiento de los datos personales</h2>

                    <h3>¿Con qué finalidad trataremos tus datos personales?</h3>
                    <p>
                    En {{NOTARIA.Nombre}}, trataremos tus datos personales recabados a través del Sitio Web: {{NOTARIA.Ruta}}, con las siguientes finalidades:
                    <ul>
                        <li>
                            En caso de contratación de los bienes y servicios ofertados a través de {{NOTARIA.Ruta}}, para mantener la relación contractual, así como la gestión, administración, información, prestación y mejora del servicio.
                        </li>
                        <li>
                            Envío de información solicitada a través de los formularios dispuestos en {{NOTARIA.Ruta}}
                        </li>
                        <li>
                            Remitir boletines (newsletters), así como comunicaciones comerciales de promociones y/o publicidad de {{NOTARIA.Nombre}} y del sector.
                        </li>
                    </ul>
                    Te recordamos que puedes oponerte al envío de comunicaciones comerciales por cualquier vía y en cualquier momento, remitiendo un correo electrónico a la dirección indicada anteriormente.
                    <br>
                    Los campos de dichos registros son de cumplimentación obligatoria, siendo imposible realizar las finalidades expresadas si no se aportan esos datos.
                    </p>

                    <h3>¿Por cuánto tiempo se conservan los datos personales recogidos?</h3>
                    <p>
                    Los datos personales proporcionados se conservarán mientras se mantenga la relación comercial o no solicites su supresión y durante el plazo por el cuál pudieran derivarse responsabilidades legales por los servicios prestados.
                    <br>
                    <b>LEGITIMACIÓN:</b>
                    <br>
                    El tratamiento de tus datos se realiza con las siguientes bases jurídicas que legitiman el mismo:
                    <br>
                    La solicitud de información y/o la contratación de los servicios de {{NOTARIA.Nombre}}, cuyos términos y condiciones se pondrán a tu disposición en todo caso, de forma previa a una eventual contratación.
                    <br>
                    El consentimiento libre, específico, informado e inequívoco, en tanto que te informamos poniendo a tu disposición la presente política de privacidad, que tras la lectura de la misma, en caso de estar conforme, puedes aceptar mediante una declaración o una clara acción afirmativa, como el marcado de una casilla dispuesta al efecto.
                    <br>
                    En caso de que no nos facilites tus datos o lo hagas de forma errónea o incompleta, no podremos atender tu solicitud, resultando del todo imposible proporcionarte la información solicitada o llevar a cabo la contratación de los servicios.
                    <br>
                    <b>DESTINATARIOS:</b>
                    <br>
                    Los datos no se comunicarán a ningún tercero ajeno a {{NOTARIA.Nombre}}, salvo obligación legal.
                    <br>
                    Como encargados de tratamiento, tenemos contratados a los siguientes proveedores de servicios, habiéndose comprometido al cumplimiento de las disposiciones normativas, de aplicación en materia de protección de datos, en el momento de su contratación:
                    <br>
                    {{NOTARIA.Nombre}}, con domicilio en Calle la Cruz, 17, 29780 Nerja, Málaga , presta servicios de Notaria.
                    <br>
                    Distribuciones Notariales (NOTIN), con domicilio en Av. Severo Ochoa, 2, 30100 Murcia, CIF: B30330104, presta servicios de Proveedor de la página web (NOTIN).
                    </p>
                    <h3>Datos recopilados por los usuarios de los servicios</h3>
                    <p>
                    En los casos en que el usuario incluya ficheros con datos de carácter personal en los servidores de alojamiento compartido, {{NOTARIA.Nombre}} no se hace responsable del incumplimiento por parte del usuario del RGPD.
                    </p>

                    <h3>Retención de datos en conformidad a la LSSI</h3>
                    <p>
                    {{NOTARIA.Nombre}} informa de que, como prestador de servicio de alojamiento de datos y en virtud de lo establecido en la Ley 34/2002 de 11 de julio de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI), retiene por un periodo máximo de 12 meses la información imprescindible para identificar el origen de los datos alojados y el momento en que se inició la prestación del servicio. La retención de estos datos no afecta al secreto de las comunicaciones y sólo podrán ser utilizados en el marco de una investigación criminal o para la salvaguardia de la seguridad pública, poniéndose a disposición de los jueces y/o tribunales o del Ministerio que así los requiera.
                    <br>
                    La comunicación de datos a las Fuerzas y Cuerpos del Estado se hará en virtud a lo dispuesto en la normativa sobre protección de datos personales.
                    </p>

                    <h2>Derechos de propiedad intelectual</h2>
                    <p>
                    NOTIN es titular de todos los derechos de autor, propiedad intelectual, industrial, “know how” y cuantos otros derechos guardan relación con los contenidos del sitio web {{NOTARIA.Ruta}} y los servicios ofertados en el mismo, así como de los programas necesarios para su implementación y la información relacionada.
                    <br>
                    No se permite la reproducción, publicación y/o uso no estrictamente privado de los contenidos, totales o parciales, del sitio web {{NOTARIA.Ruta}} sin el consentimiento previo y por escrito.
                    </p>

                    <h3>Propiedad intelectual del software</h3>
                    <p>
                    El usuario debe respetar los programas de terceros puestos a su disposición por NOTIN, aun siendo gratuitos y/o de disposición pública.
                    <br>
                    NOTIN dispone de los derechos de explotación y propiedad intelectual necesarios del software.
                    <br>
                    El usuario no adquiere derecho alguno o licencia por el servicio contratado, sobre el software necesario para la prestación del servicio, ni tampoco sobre la información técnica de seguimiento del servicio, excepción hecha de los derechos y licencias necesarios para el cumplimiento de los servicios contratados y únicamente durante la duración de los mismos.
                    <br>
                    Para toda actuación que exceda del cumplimiento del contrato, el usuario necesitará autorización por escrito por parte de NOTIN, quedando prohibido al usuario acceder, modificar, visualizar la configuración, estructura y ficheros de los servidores propiedad de NOTIN,  asumiendo la responsabilidad civil y penal derivada de cualquier incidencia que se pudiera producir en los servidores y sistemas de seguridad como consecuencia directa de una actuación negligente o maliciosa por su parte.
                    </p>
                    
                    <h3>Propiedad intelectual de los contenidos alojados</h3>
                    <p>
                    Se prohíbe el uso contrario a la legislación sobre propiedad intelectual de los servicios prestados por NOTIN y {{NOTARIA.Nombre}} y, en particular de:
                    <br>
                    La utilización que resulte contraria a las leyes españolas o que infrinja los derechos de terceros.
                    <br>
                    La publicación o la transmisión de cualquier contenido que, a juicio de {{NOTARIA.Nombre}}, resulte violento, obsceno, abusivo, ilegal, racial, xenófobo o difamatorio.
                    <br>
                    Los cracks, números de serie de programas o cualquier otro contenido que vulnere derechos de la propiedad intelectual de terceros.
                    <br>
                    La recogida y/o utilización de datos personales de otros usuarios sin su consentimiento expreso o contraviniendo lo dispuesto en Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de los mismos.
                    <br>
                    La utilización del servidor de correo del dominio y de las direcciones de correo electrónico para el envío de correo masivo no deseado.
                    <br>
                    El usuario tiene toda la responsabilidad sobre el contenido de su web, la información transmitida y almacenada, los enlaces de hipertexto, las reivindicaciones de terceros y las acciones legales en referencia a propiedad intelectual, derechos de terceros y protección de menores.
                    <br>
                    El usuario es responsable respecto a las leyes y reglamentos en vigor y las reglas que tienen que ver con el funcionamiento del servicio online, comercio electrónico, derechos de autor, mantenimiento del orden público, así como principios universales de uso de Internet.
                    <br>
                    El usuario indemnizará a NOTIN y {{NOTARIA.Nombre}} por los gastos que generara la imputación de NOTIN o {{NOTARIA.Nombre}} en alguna causa cuya responsabilidad fuera atribuible al usuario, incluidos honorarios y gastos de defensa jurídica, incluso en el caso de una decisión judicial no definitiva.
                    </p>

                    <h2>Protección de la información alojada</h2>
                    <p>
                    NOTIN realiza copias de seguridad de los contenidos alojados en sus servidores, sin embargo no se responsabiliza de la pérdida o el borrado accidental de los datos por parte de los usuarios. De igual manera, no garantiza la reposición total de los datos borrados por los usuarios, ya que los citados datos podrían haber sido suprimidos y/o modificados durante el periodo del tiempo transcurrido desde la última copia de seguridad.
                    <br>
                    Los servicios ofertados, excepto los servicios específicos de backup, no incluyen la reposición de los contenidos conservados en las copias de seguridad realizadas por NOTIN, cuando esta pérdida sea imputable al usuario; en este caso, se determinará una tarifa acorde a la complejidad y volumen de la recuperación, siempre previa aceptación del usuario.
                    <br>
                    La reposición de datos borrados sólo está incluida en el precio del servicio cuando la pérdida del contenido sea debida a causas atribuibles a {{NOTARIA.Nombre}}.
                    </p>

                    <h2>Comunicaciones Comerciales</h2>
                    <p>
                    En aplicación de la LSSI. {{NOTARIA.Nombre}} no enviará comunicaciones publicitarias o promocionales por correo electrónico u otro medio de comunicación electrónica equivalente que previamente no hubieran sido solicitadas o expresamente autorizadas por los destinatarios de las mismas.
                    <br>
                    En el caso de usuarios con los que exista una relación contractual previa,{{NOTARIA.Nombre}} sí está autorizado al envío de comunicaciones comerciales referentes a productos o servicios de {{NOTARIA.Nombre}} que sean similares a los que inicialmente fueron objeto de contratación con el cliente.
                    <br>
                    En todo caso, el usuario, tras acreditar su identidad, podrá solicitar que no se le haga llegar más información comercial a través de los canales de Atención al Cliente.
                    </p> -->

<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font ><font><font size="3" style="font-size: 12pt"><b>1.
&iquest;Qui&eacute;n es el Responsable de tratamiento de sus datos?	</b></font></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 13pt">Identidad
del Responsable:</font></font><font><font size="3" style="font-size: 13pt">&nbsp;</font></font><font><font size="3" style="font-size: 12pt"><b>UNIVERSAL DATA S.L.</b></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">NIF/CIF:</font></font><font><font size="3" style="font-size: 12pt"> B-30417778</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 13pt">Direcci&oacute;n:</font></font><font><font size="3" style="font-size: 13pt">&nbsp;Calle Doctor Severo Ochoa (ed pq. Imperial) Murcia, 30107</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Correo
electr&oacute;nico:</font></font><font><font size="3" style="font-size: 12pt">&nbsp;<a title="Enviar email a info@unidata.es" href="mailto:info@unidata.es">info@unidata.es</a></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Se
le informa que para una mayor garant&iacute;a en el cumplimiento de
la Protecci&oacute;n de datos ha sido designado a un Delegado en
Protecci&oacute;n de Datos cuyos datos de contacto es el siguiente:
</font></font><a href="mailto:dpd@aequus.es"><font><font size="3" style="font-size: 12pt"><u>dpd@aequus.es</u></font></font></a><font><font size="3" style="font-size: 12pt">.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt"><b>2.
Finalidades</b></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">&iquest;Con
qu&eacute; finalidad tratamos sus datos personales? En cumplimiento
de lo dispuesto en el Reglamento Europeo 2016/679 General de
Protecci&oacute;n de Datos, te informamos que en </font></font><font><font size="3" style="font-size: 12pt">la
Notar&iacute;a</font></font><font><font size="3" style="font-size: 12pt">
</font></font><font><font size="3" style="font-size: 12pt">tratamos
los datos que nos facilite para las siguientes finalidades:</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">1.-
</font></font><font><font size="3" style="font-size: 12pt">La
gesti&oacute;n de su consulta.	</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">2.-
</font></font><font><font size="3" style="font-size: 12pt">Env&iacute;o
de informaci&oacute;n, por v&iacute;a electr&oacute;nica o no
electr&oacute;nica, relacionada con su consulta y los servicios de la
notar&iacute;a. </font></font>
</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">3.-
</font></font><font><font size="3" style="font-size: 12pt">Servicio
de atenci&oacute;n al usuario, resoluci&oacute;n de dudas,
presentaci&oacute;n de quejas o sugerencias.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Le
recordamos que el tratamiento con las finalidades descritas es
necesario para la satisfacci&oacute;n de los intereses leg&iacute;timos
perseguidos por la Notar&iacute;a.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt"><b>3.
Tipolog&iacute;a de los datos que se tratan </b></font></font>
</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">En
el marco de las finalidades a los que se han hecho referencia, la
Notar&iacute;a y siempre condicionado a las finalidades consentidas,
trataremos las siguientes categor&iacute;as de datos:</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">-
Datos identificativos y de contacto por ejemplo a t&iacute;tulo
enunciativo, pero no limitativo: nombre, apellidos, tel&eacute;fono o
correo electr&oacute;nico.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt"><b>4.
Plazo o criterio de la conservaci&oacute;n de los datos</b></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">&iquest;Por
cu&aacute;nto tiempo conservaremos sus datos? </font></font>
</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Sus
datos ser&aacute;n conservados mientras sean necesarios para la
prestaci&oacute;n de los servicios o en su caso mientras dure la
relaci&oacute;n entre las partes, y en cualquier caso mientras no
solicite su supresi&oacute;n, as&iacute; como el tiempo necesario
para dar cumplimiento a las obligaciones legales que en cada caso
correspondan acorde con cada tipolog&iacute;a de datos.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt"><b>5.
Legitimaci&oacute;n</b></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">&iquest;Cu&aacute;l
es la legitimaci&oacute;n para el tratamiento de sus datos? </font></font>
</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">El
tratamiento de los datos personales relacionado con el mantenimiento
de su relaci&oacute;n con la Notar&iacute;a est&aacute; legitimado al
resultar necesario para dar cumplimiento a las obligaciones
contractuales derivadas de dicha relaci&oacute;n. </font></font><font><font size="3" style="font-size: 12pt">El
tratamiento de sus datos personales vinculados a dichos fines es
estrictamente necesario para dar cumplimiento a las mencionadas
obligaciones legales.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt"><b>6.
Destinatario</b></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">&iquest;A
qu&eacute; destinatarios se comunicar&aacute;n sus datos? </font></font>
</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Con
car&aacute;cter general no se ceder&aacute;n datos a terceros salvo
obligaci&oacute;n legal.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">No
obstante, sus datos podr&aacute;n ser cedidos a los destinatarios que
se indican a continuaci&oacute;n, por los motivos que se explican</font></font><font><font size="3" style="font-size: 12pt">
y en todo caso por ser necesaria dichas comunicaciones para las
finalidades derivadas de la relaci&oacute;n entre las partes</font></font><font><font size="3" style="font-size: 12pt">:</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Administraciones
P&uacute;blicas: para el cumplimiento de las obligaciones legales.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Proveedores
que precisen acceder a sus datos para la prestaci&oacute;n de
servicios que la Notar&iacute;a haya contratado a dichos proveedores,
y con los cuales la Notar&iacute;a tiene suscritos los contratos de
confidencialidad y de tratamiento de datos personales necesarios y
exigidos por la normativa para proteger su privacidad.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in; page-break-after: avoid">
<font><font size="3" style="font-size: 12pt">Le
recordamos que desde la Notar&iacute;a no se realizan transferencias
internacionales de datos.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in; background: #ffffff">
<font><font size="3" style="font-size: 12pt">Durante
el tratamiento de datos del usuario, es posible que utilicemos
software cuya procedencia o servidores est&eacute;n ubicados fuera
del Espacio Econ&oacute;mico Europeo, en particular, en pa&iacute;ses
que ofrezcan un nivel adecuado de protecci&oacute;n o en EEUU. En
esos casos, nos aseguraremos que trabajamos con proveedores que
garantizan el cumplimiento de los est&aacute;ndares y normativas
europeas en materia de protecci&oacute;n de datos aplicables, y en
particular, el RGPD (Reglamento General de Protecci&oacute;n de Datos
UE 679/2016). Las transferencias de datos a EEUU estar&aacute;n
siempre amparadas en el Escudo de Privacidad EU &ndash; EEUU. Puede
consultar m&aacute;s informaci&oacute;n en&nbsp;</font></font><a href="http://www.techoscalabuig.com/www.privacyshield.org" target="_blank"><font><font size="3" style="font-size: 12pt"><u>www.privacyshield.org</u></font></font></a><font><font size="3" style="font-size: 12pt">.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt"><b>7.
Derechos</b></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">&iquest;Cu&aacute;les
son sus derechos cuando nos facilita sus datos? </font></font>
</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Tiene
derecho a obtener confirmaci&oacute;n sobre si estamos tratando datos
personales que le conciernan, o no.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Asimismo,
tiene derecho a acceder a sus datos personales, as&iacute; como a
solicitar la rectificaci&oacute;n de los datos inexactos o, en su
caso, solicitar su supresi&oacute;n cuando, entre otros motivos, los
datos ya no sea necesarios para los fines que fueron recogidos.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">En
determinadas circunstancias, podr&aacute; solicitar la limitaci&oacute;n
del tratamiento de sus datos, en cuyo caso &uacute;nicamente los
conservaremos para el ejercicio o la defensa de reclamaciones.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">En
determinadas circunstancias y por motivos relacionados con tu
situaci&oacute;n particular, podr&aacute; oponerse al tratamiento de
sus datos. </font></font>
</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Asimismo,
puede ejercer el derecho a la portabilidad de los datos, as&iacute;
como retirar los consentimientos facilitados en cualquier momento,
sin que ello afecte a la licitud del tratamiento basado en el
consentimiento previo a su retirada.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Podr&aacute;
ejercer dichos derechos mediante petici&oacute;n escrita dirigida
enviando un correo electr&oacute;nico a </font></font><font><font size="3" style="font-size: 12pt">________________@</font></font><font><font size="3" style="font-size: 12pt">__________</font></font><font><font size="3" style="font-size: 12pt">,
adjuntando una copia de su DNI u otro documento que acredite su
identidad, e indicando claramente el derecho que quiere ejercer.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">Por
&uacute;ltimo, le informamos que puede dirigirse ante la Agencia
Espa&ntilde;ola de Protecci&oacute;n de Datos y dem&aacute;s
organismos p&uacute;blicos competentes para cualquier reclamaci&oacute;n
derivada del tratamiento de sus datos personales.</font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt"><b>8.
Procedencia</b></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<font><font size="3" style="font-size: 12pt">&iquest;C&oacute;mo
hemos obtenido sus datos? </font></font><font><font size="3" style="font-size: 12pt"><span style="background: #ffffff">Los
datos personales son obtenidos a trav&eacute;s de la web,
directamente del usuario.</span></font></font></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in; background: #ffffff">
<font><font size="3" style="font-size: 12pt">Para
una m&aacute;s informaci&oacute;n sobre la protecci&oacute;n de datos
personales le invitamos a consultar la p&aacute;gina web de la AEPD
(Agencia Espa&ntilde;ola de Protecci&oacute;n de
Datos)&nbsp;</font></font><a href="https://www.agpd.es/" target="_blank"><font><font size="3" style="font-size: 12pt"><u>https://www.agpd.es/</u></font></font></a></p>
<p lang="es-ES" class="western" align="justify" style="line-height: 107%; margin-bottom: 0in">
<br/>

</p>
                  </div>
                </v-col>
              </v-row>
              <!-- End Single Content  -->
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from '../store/index'
const store = useStore();
const { NOTARIA } = storeToRefs(store)

const PageName = "protecciondatos"
if(store.NOTARIA) useMetaTags(toRaw(store.NOTARIA),PageName)
</script>
